import type { TFunction } from 'i18next';

import { I18NextNS } from 'src/models/Language.model';

import {
  EMAIL_MAX_LENGTH,
  emailPattern,
  NAME_MAX_LENGTH,
  namePattern,
} from 'src/utils/validationRules';

export const firstNameValidators = (t: TFunction) => ({
  required: t('patientFields.firstNameRequired', { ns: I18NextNS.COMMON }),
  maxLength: {
    value: NAME_MAX_LENGTH,
    message: t('patientFields.firstNameMaxLength', { ns: I18NextNS.COMMON }),
  },
  pattern: {
    value: namePattern,
    message: t('patientFields.firstNameInvalid', { ns: I18NextNS.COMMON }),
  },
});

export const lastNameValidators = (t: TFunction) => ({
  required: t('patientFields.lastNameRequired', { ns: I18NextNS.COMMON }),
  maxLength: {
    value: NAME_MAX_LENGTH,
    message: t('patientFields.lastNameMaxLength', { ns: I18NextNS.COMMON }),
  },
  pattern: {
    value: namePattern,
    message: t('patientFields.lastNameInvalid', { ns: I18NextNS.COMMON }),
  },
});

export const emailValidators = (t: TFunction) => ({
  required: t('patientFields.emailRequired', { ns: I18NextNS.COMMON }),
  pattern: {
    value: emailPattern,
    message: t('patientFields.emailInvalid', { ns: I18NextNS.COMMON }),
  },
  maxLength: {
    value: EMAIL_MAX_LENGTH,
    message: t('patientFields.emailMaxLength', { ns: I18NextNS.COMMON }),
  },
});
